import React, { useState } from "react";
import {
  MobileAlertOverlay,
  MobileAlertCard,
  MobileAlertTitle,
  MobileAlertMessage,
  MobileAlertInstruction,
} from "../MobileAlert/styled";
import { CopyRow, LinkPreview, CopyButton } from "./styled";

interface UnsupportedBrowserProps {
  /** Nombre de la app cuyo webview detectamos, si lo conocemos. */
  inAppBrowser?: string | null;
  translations: {
    title: string;
    message: string;
    messageInApp: (app: string) => string;
    instruction: string;
    copyLink: string;
    copied: string;
  };
}

/**
 * Pantalla que ve el candidato cuando su navegador no expone el micrófono
 * (típicamente el navegador embebido de Gmail, LinkedIn o Instagram).
 * Antes de esto, ese caso terminaba en una página en blanco.
 */
const UnsupportedBrowser: React.FC<UnsupportedBrowserProps> = ({
  inAppBrowser,
  translations,
}) => {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.href : "";

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch {
      // Sin permiso de portapapeles: el enlace queda visible para copiarlo a mano.
      setCopied(false);
    }
  };

  return (
    <MobileAlertOverlay>
      <MobileAlertCard>
        <MobileAlertTitle>{translations.title}</MobileAlertTitle>
        <MobileAlertMessage>
          {inAppBrowser
            ? translations.messageInApp(inAppBrowser)
            : translations.message}
        </MobileAlertMessage>
        <MobileAlertInstruction>
          {translations.instruction}
        </MobileAlertInstruction>
        <CopyRow>
          <LinkPreview>{url}</LinkPreview>
          <CopyButton onClick={copyLink}>
            {copied ? translations.copied : translations.copyLink}
          </CopyButton>
        </CopyRow>
      </MobileAlertCard>
    </MobileAlertOverlay>
  );
};

export default UnsupportedBrowser;
